import React from "react";
import classnames from "classnames";
import { useStateValue } from "../../context-store/AppStateProvider";
import { ACTIONS } from "../../context-store/ACTIONS";
import { Modal } from "@instructure/ui-modal";
import { Heading } from "@instructure/ui-heading";
import { Button, CloseButton } from "@instructure/ui-buttons";
import { Text } from "@instructure/ui-text";
import styles from "./InfoModal.module.scss";

const IasInfoModal = ({ title, bodyText }) => {
  const [{ isInfoModalOpen }, dispatch] = useStateValue();

  const closeModal = () => {
    dispatch({ type: ACTIONS.TOGGLE_INFO_MODAL });
  };

  return (
    <div className={classnames(styles.InfoModal)}>
      <Modal
        as="main"
        open={isInfoModalOpen}
        insertAt={"bottom"}
        onDismiss={closeModal}
        size="auto"
        label={title}
        shouldCloseOnDocumentClick
      >
        <Modal.Header>
          <Heading>{title}</Heading>
          <CloseButton
            placement="end"
            offset="small"
            onClick={closeModal}
            screenReaderLabel="Close"
          />
        </Modal.Header>
        <Modal.Body>
          <Text lineHeight="double">{bodyText}</Text>
        </Modal.Body>
        <Modal.Footer>
          <Button color="primary-inverse" type="button" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default IasInfoModal;
